define([
  'es6!sumo/util',
  'immutable',
  'es6!launcher/actions/Actions',
], (Util, Immutable, Actions) => {
  const initialState = Immutable.Map({
    modalBodyHeight: 0,
    modalBodyFullscreenOverlay: false,
    listbuilderBodyHeight: 0,
    proHeaderHeight: 0,
    alertHeaderHeight: 0,
  });

  const actionHandlers = {};

  actionHandlers[Actions.RESIZE_MODAL] = (state, action) => {
    let newState = state;

    newState = newState.set('modalBodyHeight', action.modalBodyHeight);
    newState = newState.set('proHeaderHeight', action.proHeaderHeight);
    newState = newState.set('alertHeaderHeight', action.alertHeaderHeight);

    return newState;
  };

  actionHandlers[Actions.UPDATE_APP_STATE] = (state, action) => (
    state.set(action.state, action.value)
  );

  return Util.createReducer(initialState, actionHandlers);
});
